if (!customElements.get('fb-load-more')) {
  customElements.define('fb-load-more', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.list = this.closest('results-list');
      this.grid = this.list?.querySelector('[ref="grid"]');
      this.button = this.querySelector('button');
      if (!this.grid || !this.button) return;
      this.label = this.button.textContent;
      this.loads = 0;
      this.querySelector('[data-fallback]')?.setAttribute('hidden', '');
      this.updateCount();
      this.button.addEventListener('click', () => this.load(true));
      this.savePosition = () => {
        if (!this.loads) return;
        history.replaceState({...history.state, fbCollection: {key: location.href, loads: this.loads, scroll: window.scrollY}}, '', location.href);
      };
      this.list.addEventListener('click', this.savePosition);
      const saved = history.state?.fbCollection;
      if (saved?.key === location.href && performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
        this.restore(saved);
      }
    }
    disconnectedCallback() {
      this.list?.removeEventListener('click', this.savePosition);
      this.controller?.abort();
    }
    updateCount() {
      const count = this.grid.querySelectorAll(':scope > [data-product-id]').length;
      this.querySelector('[data-count]').textContent = this.dataset.countTemplate.replace('[count]', count).replace('[total]', this.dataset.total);
      this.button.hidden = !this.button.dataset.next;
    }
    async restore(saved) {
      for (let i = 0; i < saved.loads; i++) {
        if (!await this.load(false)) break;
      }
      window.scrollTo({top: saved.scroll, behavior: 'instant'});
    }
    async load(focus) {
      if (this.loading || !this.button.dataset.next) return false;
      this.loading = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.loading;
      const error = this.querySelector('[data-error-message]');
      error.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      try {
        const url = new URL(this.button.dataset.next, location.href);
        url.searchParams.set('section_id', this.list.getAttribute('section-id'));
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Unable to load products');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.querySelector('[ref="grid"]');
        const controls = page.querySelector('fb-load-more');
        if (!nextGrid || !controls) throw new Error('Missing collection');
        const existing = new Set([...this.grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
        const cards = [...nextGrid.querySelectorAll(':scope > [data-product-id]')].filter(card => !existing.has(card.dataset.productId));
        this.grid.append(...cards);
        this.button.dataset.next = controls.querySelector('button')?.dataset.next || '';
        this.loads++;
        this.updateCount();
        if (focus) cards[0]?.querySelector('a')?.focus({preventScroll: true});
        this.savePosition();
        return true;
      } catch (failure) {
        if (failure.name !== 'AbortError') {
          error.textContent = this.dataset.error;
          error.hidden = false;
        }
        return false;
      } finally {
        this.loading = false;
        this.button.disabled = false;
        this.button.textContent = this.label;
        this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
